// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AppointmentModel } from './appointmentModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class BmsGetNextBusinessDaysResponseModel {
    'appointmentDates': Array<AppointmentModel>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof BmsGetNextBusinessDaysResponseModel>> = [
        {
            "name":     "appointmentDates",
            "baseName": "appointmentDates",
            "type":     "Array<AppointmentModel>"
        },
    ];

    static getAttributeTypeMap() {
        return BmsGetNextBusinessDaysResponseModel.attributeTypeMap;
    }
}
